export default __webpack_public_path__ + "static/realworldIcon-36ab1281ad5ca2f49f9c6b435bed0512.png";